export const PACKAGE_STATUSES221 = ['draft', 'review', 'approved', 'scheduled', 'published', 'republished', 'retired'] as const;
export type PackageStatus221 = (typeof PACKAGE_STATUSES221)[number];

export const packageStatusLabels221: Record<PackageStatus221, string> = {
  draft: '초안',
  review: '검수 중',
  approved: '승인',
  scheduled: '예약',
  published: '게시',
  republished: '수정 게시',
  retired: '종료',
};

export const WARNING_CODES221 = [
  'duplicateArticle', 'missingSource', 'missingNumbers', 'hardSentence',
  'unclearAnswer', 'rewardHeavy', 'repeatedContent', 'puzzleConflict',
] as const;
export type WarningCode221 = (typeof WARNING_CODES221)[number];

export const warningLabels221: Record<WarningCode221, string> = {
  duplicateArticle: '유사 기사 중복',
  missingSource: '출처·기준일 누락',
  missingNumbers: '숫자·사실 누락',
  hardSentence: '어려운 문장',
  unclearAnswer: '정답 불명확',
  rewardHeavy: '보상 과다',
  repeatedContent: '이전 콘텐츠 반복',
  puzzleConflict: '퍼즐 종료일 충돌',
};

export interface PackageWarning221 { code: WarningCode221; message: string }

export interface PackageVersion221 {
  version: number;
  status: PackageStatus221;
  approvedBy: string;
  approvedAt: string;
  note: string;
}

/** Warnings advise; they never block. Acknowledging records that a person looked. */
export function unacknowledged221(warnings: PackageWarning221[], acknowledged: WarningCode221[]): PackageWarning221[] {
  return warnings.filter((warning) => !acknowledged.includes(warning.code));
}

export function canApprove221(warnings: PackageWarning221[], acknowledged: WarningCode221[], completion: number, primaryRewardCount: number): boolean {
  return completion >= 100 && primaryRewardCount <= 2 && unacknowledged221(warnings, acknowledged).length === 0;
}

export function primaryRewardCount221(reward: { points: number; iceBricks: number; puzzlePieces: number; specialBrickType: string }): number {
  return [reward.points > 0, reward.iceBricks > 0, reward.puzzlePieces > 0, reward.specialBrickType !== 'none'].filter(Boolean).length;
}

/** The version a rollback would restore: the newest live one below the current. */
export function rollbackTarget221(versions: PackageVersion221[], liveVersion: number): PackageVersion221 | undefined {
  return versions
    .filter((item) => ['published', 'republished'].includes(item.status) && item.version < liveVersion)
    .sort((a, b) => b.version - a.version)[0];
}

/** Rollback adds a version rather than removing one, so history only grows. */
export function historyIsComplete221(versions: PackageVersion221[]): boolean {
  const numbers = versions.map((item) => item.version).sort((a, b) => a - b);
  return numbers.every((value, index) => value === numbers[0] + index);
}
